import React, { useMemo, useState } from 'react'

export const ModalContext = React.createContext({
  activeModal: null,
  setActiveModal: () => {}
})

export const ModalContextProvider = props => {
  const [activeModal, setActiveModal] = useState(null)
  const state = useMemo(
    () => ({
      activeModal,
      setActiveModal
    }),
    [activeModal]
  )

  return (
    <ModalContext.Provider value={state}>
      {props.children}
    </ModalContext.Provider>
  )
}
